import type { Resource } from '../../';
export const general_errors_renderAlerts_seeDetails: Resource = {"default":"See Details"};
